import type { CosmeticProfileCriteria } from '@/features/profiles/types/avatar-catalog'

/**
 * Traduz o `criteria` do cosmético nas linhas que o card bloqueado exibe.
 *
 * O front não avalia nenhuma regra — quem decide bloqueio e elegibilidade é o
 * backend (`unlock_eligible`). Aqui só se descreve, para o aluno, o que o
 * payload já declara.
 */
export function cosmeticCriteriaLines(
  criteria: CosmeticProfileCriteria
): string[] {
  const lines: string[] = []

  if (criteria.points_cost != null && criteria.points_cost > 0) {
    lines.push(`${criteria.points_cost} pts`)
  }
  if (criteria.mission_ids?.length) {
    lines.push(`Missões: ${criteria.mission_ids.join(', ')}`)
  }
  if (criteria.level_ids?.length) {
    lines.push(`Níveis: ${criteria.level_ids.join(', ')}`)
  }
  if (criteria.journey_ids?.length) {
    lines.push(`Jornadas: ${criteria.journey_ids.join(', ')}`)
  }
  if (criteria.reward_item_ids?.length) {
    lines.push(`Recompensas: ${criteria.reward_item_ids.join(', ')}`)
  }
  if (criteria.available_from || criteria.available_until) {
    const a = criteria.available_from ?? '—'
    const b = criteria.available_until ?? '—'
    lines.push(`${a} → ${b}`)
  }
  // Linhas separadas de propósito: exigir e excluir campanha são condições
  // opostas, e um mesmo cosmético pode ter as duas.
  if (criteria.campaign_names?.length) {
    lines.push(`Campanhas: ${criteria.campaign_names.join(', ')}`)
  }
  if (criteria.excluded_campaign_names?.length) {
    lines.push(`Exceto campanhas: ${criteria.excluded_campaign_names.join(', ')}`)
  }

  return lines
}
